import React from "react";
import LoginTemplate from "../../../core/components/__templates/LoginTemplate/LoginTemplate";

export default function Login() {
  return <LoginTemplate/>
}


